import { render, staticRenderFns } from "./ObjectOverviewItem.vue?vue&type=template&id=c794f652&"
import script from "./ObjectOverviewItem.vue?vue&type=script&lang=js&"
export * from "./ObjectOverviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports